mod.modules.define("TemplateDrawer", "BaseDrawer", function(fn) {

	var cache = {
		$window: null,
		$visibleList: null,
		$hiddenList: null,
		$editModal: null,
		$saveModal: null,
		$newTemplateModal: null,
		$clientTemplates: null
	};

	fn.prototype.dockSize = 10;
	fn.prototype._dockSpeed = 250;
	fn.prototype.maxClientTemplates = 10;

	// A list of all the widgets and where they are on the page
	fn.prototype.modules = [];

	// A list of all the available module names
	fn.prototype.moduleTypes = {};

	fn.prototype.init = function(params) {
		this.base("init", params);

		// Capture params
		this.moduleTypes = params.moduleTypes || {};
		this.isClientTemplate = (params.templateType == "client"); // else it is predefined
		this.currentTemplateName = params.templateName || "";
		this.predefinedModules = params.predefinedModules || "";

		// Cache
		cache.$window = $(window);
		cache.$visibleList = this.el.find("div.drawer-template-visible");
		cache.$hiddenList = this.el.find("div.drawer-template-hidden");
		cache.$editModal = $("#template-edit-modal");
		cache.$saveModal = $("#template-save-modal");
		cache.$newTemplateModal = $("#template-new-modal");
		cache.$clientTemplates = this.el.find("ul.drawer-template-client");
		cache.$originalDrawerTop = this.el.position().top;
		cache.$ColumnCount = params.columnCount || 4;

		// Throw some events on the window
		cache.$window
			.on("scroll", $.proxy(this.handle_windowScroll, this))
			.on("resize", $.proxy(this.handle_windowResize, this));

		// Listen to widgets repositioning
		mod.observer.trigger("modules - position requested", this._receivemodules);
	};

	fn.prototype.handle_windowScroll = function() {
		this._highlightVisibleModules();
		this._scrollDrawer();
	};

	fn.prototype.handle_windowResize = function() {
		this._highlightVisibleModules();
	};

	fn.prototype._receivemodules = function(positions) {
		this.modules = positions;

		this._updateVisibleModules(positions);
		this._updateHiddenModules(positions);
	};

	fn.prototype._updateVisibleModules = function(modules) {
		var maxRowsPerColumn = Math.ceil(modules.length / cache.$ColumnCount);
		var columns = [];

		for (var c = 0; c < cache.$ColumnCount; c++) {
			var startIndex = c * maxRowsPerColumn;
			var columnModules = modules.slice(startIndex, startIndex + maxRowsPerColumn);
			var column = $("<ul class='drawer-template-sublist' />");

			for (var i = 0; i < columnModules.length; i++) {
				var module = columnModules[i];

				column.append(
					$("<li data-moduleid='" + module.id + "' />").append(
						$("<a href='javascript:;'>" + module.title + "</a>")
					)
				);
			}

			columns.push(column);
		}

		cache.$visibleList.empty().append(columns);
	};

	fn.prototype._updateHiddenModules = function(modules) {
		// Get the types out in the field
		var existingTypes = $.map(modules, function(module) {
			return module.type;
		});

		// Get the hidden types
		var missingTypes = $.map(this.moduleTypes, function(value, key) {
			if ($.inArray(key, existingTypes) == -1) {
				return key;
			}
		});

		// Sort them alphabetically
		missingTypes.sort($.proxy(this._sortModulesAlpha, this));

		var maxRowsPerColumn = Math.ceil(missingTypes.length / cache.$ColumnCount);
		var columns = [];

		// Add each column
		for (var c = 0; c < cache.$ColumnCount; c++) {
			var startIndex = c * maxRowsPerColumn;
			var columnModules = missingTypes.slice(startIndex, startIndex + maxRowsPerColumn);
			var column = $("<ul class='drawer-template-sublist' />");

			// Add modules to the column
			for (var i = 0; i < columnModules.length; i++) {
				var type = columnModules[i];
				var name = this.moduleTypes[type];
				var size = 1;
				var widgetId = mod.modules.getKeyFromTypeSize(type, size);

				column.append(
					$("<li />").append(
						$("<a href='javascript:;'>" + name + "</a>").attr({
							"data-type": type,
							"data-size": size,
							"data-widgetid": widgetId
						})
					)
				);
			}

			columns.push(column);
		}

		cache.$hiddenList.empty().append(columns);
	};

	fn.prototype._sortModulesAlpha = function(a, b) {
		var aName = this.moduleTypes[a].toLowerCase();
		var bName = this.moduleTypes[b].toLowerCase();

		if (aName > bName) {
			return 1;
		}
		else if (aName < bName) {
			return -1;
		}

		return 0;
	};

	fn.prototype.isScrolledIntoView = function(elem) {
		var isInView = false;

		if (elem) {
			var $elem = $(elem);
			var docViewTop = cache.$window.scrollTop();
			var docViewBottom = docViewTop + cache.$window.height();
			var elemTop = $elem.offset().top;
			var elemBottom = elemTop + $elem.height();

			var isBottomAboveTop = (elemBottom >= docViewTop);
			var isTopBelowBottom = (elemTop <= docViewBottom);
			var isBottomBelowBottom = (elemBottom <= docViewBottom);
			var isTopAboveTop = (elemTop >= docViewTop);

			isInView = (isBottomAboveTop && isTopBelowBottom && isBottomBelowBottom && isTopAboveTop);
		}

		return isInView;
	};

	fn.prototype._highlightVisibleModules = function() {
		var $listItems = cache.$visibleList.find("li").removeClass("bold");

		// Keep track of whether we've seen anything come into view yet
		// This will let us shortcut the visibility check inside the loop
		var haveSeenModuleInView = false;

		for (var i = 0; i < this.modules.length; i++) {
			var module = this.modules[i];

			// using isScrolledIntoView instead of jquery visible plugin since 
			// the requirement is that the entire module be visible to be highlighted.
			// The visible plugin returns true if any portion of the module is visible.
			// this function only returns true if the entire module is visible (in the viewport).
			if (this.isScrolledIntoView(module.el)) {
				$listItems.eq(i).addClass("bold");
				haveSeenModuleInView = true;
			}
			else if (haveSeenModuleInView) {
				break;
			}
		}
	};

	fn.prototype._scrollDrawer = function(moveInstantly) {
		var duration = 200;

		if (moveInstantly) {
			duration = 0;
		}

		this.el.clearQueue().animate({
			top: cache.$originalDrawerTop + cache.$window.scrollTop()
		}, duration);
	};

	// Modal save and delete buttons
	fn.prototype._handleTemplateModalButton = function($el) {
		var action = $el.data("action");

		if (action == "save-template") {
			this._saveTemplate($el);
		}
		else if (action == "delete-template") {
			this._deleteTemplate();
		}
	};

	// Update modal content depending on if it's a client or predefined template
	fn.prototype._initSaveTemplate = function($el) {
		var text = "";
		if (this.isClientTemplate) {
			$el.find("div.input").hide();
			text = "Changes have been made to <b>" + this.currentTemplateName + "</b>, would you like to save these changes?"
		} else {
			$el.find("div.input").show();
			text = "You have made adjustments to <b>Value Line Template " + this.currentTemplateName + "</b>, would you like to save these as a custom template?";
		}

		$el.find("p").html(text);
	};

	// Validate template name before saving
	fn.prototype._saveTemplate = function($el) {
		// If there is no name input then use the current template name
		var name = this.currentTemplateName;

		var inputDiv = $el.parents("div.modal").find("div.input");

		if (inputDiv.css("display") != "none") {
			var value = inputDiv.find("input").val();
			if (value.replace(/\s/g, '').length) {
				var re = /^[0-9a-zA-Z ]+$/;
				if (re.test(value)) {
					name = value;
				} else {
					alert("Please enter alphanumeric characters only.");
					return false;
				}
			} else {
				alert("Please enter a template name.");
				return false;
			}
		}

		var type = $el.data("type");

		// If editing, it's a rename
		if (type == "edit") {
			this._renameTemplate(name);
		} else {
			this._saveNewTemplate(name, type);
		}
	};

	fn.prototype._renameTemplate = function(newName) {
		var self = this;
		var oldName = cache.$editModal.find("input").data("oldname");

		if (newName != oldName) {
			//call RenameSavedTemplate
			$.ajax({
				type: "POST",
				data: { oldName: oldName, newName: newName },
				dataType: "json",
				url: "~/Research/RenameSavedTemplate".resolveUrl(),
				success: function() {
					// If this is the current template then reload the template, otherwise reload the drawer
					if (self.currentTemplateName == oldName) {
						self.reloadTemplate(newName);
					} else {
						self.reload();
					}
				},
				error: function() {
					alert("There was an error renaming the template.");
				}
			});
		}

		cache.$editModal.modal("hide");
	};

	fn.prototype._deleteTemplate = function() {
		var self = this;
		var name = cache.$editModal.find("input").data("oldname");

		if (name.length > 0) {
			//call DeleteSavedTemplate
			$.ajax({
				type: "POST",
				data: { name: name },
				dataType: "json",
				url: "~/Research/DeleteSavedTemplate".resolveUrl(),
				success: function() {
					if (self.currentTemplateName == name) {
						// If deleting the current template then reload page with default template
						self.reloadTemplate(null);
					} else {
						// Remove template
						self.el.find(".drawer-template-client [data-templateid=\"" + name + "\"]").remove();
					}
				},
				error: function() {
					alert("There was an error deleting the template.");
				}
			});
		}

		cache.$editModal.modal("hide");
	};

	fn.prototype._saveNewTemplate = function(name, type) {
		var self = this;
		var oData = {};
		oData.name = name;

		var currentModal = cache.$newTemplateModal;

		// Type can be new or save, if it's a new template the module list will be the predefined list
		if (type == "save") {
			var moduleList = {};

			for (var i = 0; i < this.modules.length; i++) {
				moduleList[this.modules[i].typestr] = this.modules[i].size;
			}

			oData.modules = JSON.stringify(moduleList);
			currentModal = cache.$saveModal;
		} else {
			oData.modules = this.predefinedModules;
		}

		//call AddSavedTemplate        
		$.ajax({
			type: "POST",
			data: oData,
			dataType: "json",
			url: "~/Research/AddSavedTemplate".resolveUrl(),
			success: function() {
				// Load this template
				self.reloadTemplate(name);
			},
			error: function() {
				alert("There was an error saving the template.");
			}
		});

		currentModal.modal("hide");
	};

	fn.prototype.reloadTemplate = function(id) {
		this.reloadQueue({
			UserTemplateId: id
		});

		mod.observer.trigger("template changed", id, this.reloadDequeue);
	};

	fn.prototype.scrollToModule = function(moduleId) {
		var self = this;
		var moduleTop = 0;

		// Find the matching module based on id
		for (var i = this.modules.length - 1; i >= 0; i--) {
			var module = this.modules[i];

			if (module.id == moduleId) {
				moduleTop = module.top;
				break;
			}
		}

		// Scroll the window to the module
		// NOTE: if you want the module at the very top of the screen, you'll need
		// to subtract the distance from the first module to the top of the document
		window.scrollTo(window.scrollLeft, moduleTop);
		this._scrollDrawer(true);
		this.action_dock();
	};

	fn.prototype.observables = {
		"modules - repositioned": function(params) {
			this._receivemodules(params);
			this._highlightVisibleModules();
		},
		"modules - scrollTo": function(id) {
			this.scrollToModule(id);
		},
		"template - save modal show": function($el) {
			this._initSaveTemplate($el);
		},
		"template - modal button clicked": function($el) {
			this._handleTemplateModalButton($el);
		}
	};

	fn.prototype.events = {
		"#template-list": {
			"show": function(e, $el) {
				this.el.find("div.module-list").hide();
				this.el.find(".accordion-modules").parents(".accordion-group").addClass("open");
				this.el.find("span.caret").addClass("caret-open");
			},
			"hide": function(e, $el) {
				this.el.find("div.module-list").show();
				this.el.find(".accordion-modules").parents(".accordion-group").removeClass("open");
				this.el.find("span.caret").removeClass("caret-open");
			}
		},
		".drawer-template-client [data-templateid] a": {
			"click": function(e, $el) {
				var id = $el.parent().attr("data-templateid");

				if ($el.hasClass("edit")) {
					cache.$editModal.find("input").val(id).data("oldname", id);
					cache.$editModal.modal("show");
				} else {
					this.reloadTemplate(id);
				}
			}
		},
		".drawer-template-predefined [data-templateid]": {
			"click": function(e, $el) {
				// Reload the module w/o any template and it will default to
				// the value line assigned one
				this.reloadTemplate(null);
			}
		},
		".drawer-template-hidden a[data-widgetid]:not(.disabled)": {
			"click": function(e, $el) {
				$el.addClass("disabled");

				var widgetId = $el.attr("data-widgetid");
				var widgetSize = $el.attr("data-size");
				var widgetType = $el.attr("data-type");

				mod.observer.trigger("new module requested", {
					type: widgetType,
					size: widgetSize,
					id: widgetId,
					context: this.getContext()
				});
			}
		},
		".drawer-template-visible li": {
			"click": function(e, $el) {
				var moduleId = $el.attr("data-moduleid");
				this.scrollToModule(moduleId);
			}
		},
		"button[data-action=template-modal]": {
			"click": function(e, $el) {
				// Check if max number of saved templates has been reached before displaying the modal
				var numTemplates = cache.$clientTemplates.find("li").length;
				var modalId = $el.data("modal");

				// Allow template changes to be saved if a client template is in context
				if ((this.isClientTemplate && !modalId.match("new")) || (numTemplates < this.maxClientTemplates)) {
					$(modalId).find("input").val("");
					$(modalId).modal("show");
				} else {
					alert("You have saved the maximum number of templates.")
				}
			}
		}
	};

});